module.exports = __webpack_public_path__ + "img/bg_festa1.62d96110.jpg";